var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBigRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 40,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.897 25.845.096-.094.077-.11a.258.258 0 0 1 .035-.04c.372-.223.752-.566.966-1.101.187-.467.18-.924.146-1.252a41.247 41.247 0 0 1 6.09-20.53l.015-.024.014-.025a.592.592 0 0 1 1.045.02l.03.057.034.055a38.587 38.587 0 0 1 4.56 10.29l.003.01.003.01a40.954 40.954 0 0 1 1.635 10.73c.003.554.222 1.086.613 1.482l.075.076.086.066a5.48 5.48 0 0 1 2.17 4.335v6.969l-.105-.144c-.908-1.242-1.843-2.52-2.827-3.732a6.153 6.153 0 0 0-5.162-2.378h-3.248a6.687 6.687 0 0 0-5.53 2.894l-2.613 3.47-.014-6.9a6.082 6.082 0 0 1 1.806-4.134Z",
  stroke: "#0073F5",
  strokeWidth: 3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.038 17.296a2.14 2.14 0 1 1-4.28 0 2.14 2.14 0 0 1 4.28 0Z",
  stroke: "#0073F5",
  strokeWidth: 1.6
})));
export default SvgBigRocket;